import styled, { css } from "styled-components"
import { Link } from "react-router-dom"

import { formatDate } from "utils/utils"

import DotButton from "components/presenters/button/DotButton"

import checkIcon from "images/icon/check_icon-58x42.png"
import closeIcon from "images/icon/close_icon-46x46.png"
import camaraIcon from "images/icon/camara_white_icon-43×35.png"

export default function TodoItem({
	task,
	relation,
	onClickUploadBtn,
	onError,
	disableEditTask,
	onOptionBtnClick,
}) {
	const LeftBtn = () => {
		const leftBtn = []
		if (Array.isArray(task.proof) && task["proof"].length > 0) {
			if (["self", "friend"].includes(relation)) {
				const path = relation === "self" ? `/task/${task.no}` : `/task/${task.no}`
				leftBtn.push(
					<Link key={`task-item-btn-${task["no"]}`} to={path}>
						<ItemLeftWhiteBlock>
							<ItemLeftCompleteImgBlock>
								<Image src={checkIcon} />
							</ItemLeftCompleteImgBlock>
						</ItemLeftWhiteBlock>
					</Link>
				)
			} else if (relation === "other") {
				leftBtn.push(
					<ItemLeftWhiteBlock
						key={`task-item-btn-${task["no"]}`}
						onClick={() => {
							if (onError) {
								onError({
									error: "INVALID_RELATION_STATUS",
									error_detail: "FRIEND_STATUS_REQUIRED",
								})
							}
						}}
					>
						<ItemLeftCompleteImgBlock>
							<Image src={checkIcon} />
						</ItemLeftCompleteImgBlock>
					</ItemLeftWhiteBlock>
				)
			}
		} else if (formatDate() > formatDate(task["task_date"])) {
			leftBtn.push(
				<ItemLeftWhiteBlock key={`task-item-btn-${task["no"]}`}>
					<ItemLeftFailImgBlock>
						<Image src={closeIcon} />
					</ItemLeftFailImgBlock>
				</ItemLeftWhiteBlock>
			)
		} else if (formatDate() < formatDate(task["task_date"])) {
			leftBtn.push(
				<ItemLeftActiveBlock
					key={`task-item-btn-${task["no"]}`}
					onClick={() => {
						if (onError && relation === "self") {
							onError({
								error: "INVALID_TO_SUBMIT",
								error_detail: "SUBMITION_TIME_OUT_STARTED",
							})
						}
					}}
				>
					<ItemLeftCamaraImgBlock>
						<Image src={camaraIcon} />
					</ItemLeftCamaraImgBlock>
				</ItemLeftActiveBlock>
			)
		} else {
			if (relation === "self") {
				leftBtn.push(
					<ItemLeftActiveBlock
						key={`task-item-btn-${task["no"]}`}
						onClick={onClickUploadBtn}
					>
						<ItemLeftCamaraImgBlock>
							<Image src={camaraIcon} />
						</ItemLeftCamaraImgBlock>
					</ItemLeftActiveBlock>
				)
			} else {
				leftBtn.push(
					<ItemLeftActiveBlock key={`task-item-btn-${task["no"]}`}>
						<ItemLeftCamaraImgBlock>
							<Image src={camaraIcon} />
						</ItemLeftCamaraImgBlock>
					</ItemLeftActiveBlock>
				)
			}
		}
		return leftBtn
	}

	return (
		<TodoItemBlock>
			<TodoItemLeft>
				<LeftBtn />
			</TodoItemLeft>
			<TodoItemRight>
				{Array.isArray(task.proof) && task["proof"].length > 0 ? (
					<Link style={{ width: '100%' }} to={`/task/${task.no}`}>
						<TodoItemTitle>{task.title}</TodoItemTitle>
					</Link>
				) : formatDate() === formatDate(task["task_date"]) && relation === "self" ? (
					<TodoItemTitle onClick={onClickUploadBtn}>{task.title}</TodoItemTitle>
				) : (
					<TodoItemTitle>{task.title}</TodoItemTitle>
				)}
			</TodoItemRight>
			{![null, undefined].includes(onOptionBtnClick) && !disableEditTask ? (
				<DotButton onClick={onOptionBtnClick} />
			) : null}
		</TodoItemBlock>
	)
}

const TodoItemBlock = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding: calc(100vw * (12.5 / 375)) 0;
`

const TodoItemLeft = styled.div`
	margin-right: calc(100vw * (15 / 375));
`

const itemLeftStyle = css`
	display: flex;
	align-items: center;
	justify-content: center;
	width: calc(100vw * (42 / 375));
	height: calc(100vw * (42 / 375));
	border-radius: 100%;
	overflow: hidden;
`

const ItemLeftWhiteBlock = styled.div`
	${itemLeftStyle}
	background: #FFF;
`

const ItemLeftActiveBlock = styled.div`
	${itemLeftStyle}
	background: #FFCF19;
	box-shadow: 0px 2px 8px rgba(255, 220, 89, 0.88);
`

const ItemLeftCamaraImgBlock = styled.div`
	width: calc(100vw * (21 / 375));
	height: calc(100vw * (17 / 375));
`

const ItemLeftCompleteImgBlock = styled.div`
	width: calc(100vw * (25 / 375));
	height: calc(100vw * (17 / 375));
`

const ItemLeftFailImgBlock = styled.div`
	width: calc(100vw * (23 / 375));
	height: calc(100vw * (23 / 375));
`

const Image = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`

const TodoItemRight = styled.div`
	width: 100%;
`

const TodoItemTitle = styled.div`
	font-size: calc(100vw * (14 / 375));
	font-weight: 400;
	line-height: calc(100vw * (20.27 / 375));
`
